import moment from 'moment';
import { useTranslation } from 'react-i18next';

const DurationLabel = ({ startDateTime, endDateTime }) => {
  const { t } = useTranslation();
  const daysLabel = t('days');
  const dayLabel = t('day');
  const hoursLabel = t('hours');
  const hourLabel = t('hour');
  const minutesLabel = t('minutes');
  const minuteLabel = t('minute');
  // Calculate the duration
  const duration = moment.duration(
    moment(endDateTime).diff(moment(startDateTime))
  );

  // Extract days, hours, and minutes
  const days = duration.days();
  const hours = duration.hours();
  const minutes = duration.minutes();

  const dLabel = days > 1 ? daysLabel : dayLabel;
  const hLabel = hours > 1 ? hoursLabel : hourLabel;
  const mLabel = minutes > 1 ? minutesLabel : minuteLabel;

  // Build the formatted duration string
  const formattedDuration = [
    days > 0 ? `${days} ${dLabel}` : '',
    hours > 0 ? `${hours} ${hLabel}` : '',
    minutes > 0 ? `${minutes} ${mLabel}` : '',
  ]
    .filter(Boolean) // Remove empty values
    .join(' ');

  return <>{formattedDuration}</>;
};

export default DurationLabel;
